const OnBack = ({ size = 48, onClick }) => (
  <svg
    id="OnBack"
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 48 48"
    fill="none"
    onClick={onClick}
  >
    <path
      d="M27 42C32.5229 42 37 37.2991 37 31.5C37 25.701 32.5229 21 27 21C21.4771 21 17 25.701 17 31.5C17 37.2991 21.4771 42 27 42Z"
      fill="#FFB3B3"
    />
    <path
      d="M11.4926 9C8.81658 11.6467 6.1317 14.2859 3.4497 16.9277C2.8527 17.5155 2.8527 18.4787 3.4497 19.0664C6.1437 21.7131 8.83758 24.3611 11.5406 27L13.6375 24.8613C11.8256 23.0663 9.99864 21.2854 8.17767 19.5H33.7526C38.3486 19.5 41.9996 23.1536 41.9996 27.75C41.9996 32.3464 38.3486 36 33.7526 36H3.00256V39H33.7526C39.9565 39 44.9996 33.9565 44.9996 27.75C44.9996 21.5435 39.9565 16.5 33.7526 16.5H8.15954C9.97154 14.7097 11.7836 12.9219 13.6016 11.1387L11.4926 9Z"
      fill="#5A348C"
    />
  </svg>
);

export default OnBack;
